import type { CatalogEventKind } from '@steado/admin-contract/catalog-history';

import { Badge, type BadgeTone } from '@/components/ui/badge';

import { SOURCE_LABELS } from './event-copy';

/**
 * One tone per source, so a list of events reads at a glance: the console
 * blue, a request violet, a pushed batch amber, a revert grey, and a write
 * nobody made outlined rather than filled.
 */
const SOURCE_TONES: Readonly<Record<CatalogEventKind, BadgeTone>> = {
  console: 'info',
  request: 'purple',
  batch: 'warn',
  revert: 'mute',
  system: 'outline',
};

export function SourceChip({ kind }: { readonly kind: CatalogEventKind }) {
  return <Badge tone={SOURCE_TONES[kind]}>{SOURCE_LABELS[kind]}</Badge>;
}
